export default __webpack_public_path__ + "static/media/1_0054.9ab298f8.webp";